import { Endpoint, MutationConfig, Request, RequestTypes } from '~/models/request';
import { UseMutationOptions } from '@tanstack/react-query';
import { formatEndpoint, handleError, request } from '~/utils/api/requests';

export const get = <Data = unknown, Variables = void, Error = void>(
	endpoint: Endpoint,
	config: MutationConfig<Data, Error, Variables> | undefined
) =>
	mutationWrapper<Data, Error, Variables>('GET', {
		endpoint,
		config: config ?? {},
	});

export const del = <Data = unknown, Variables = void, Error = void>(
	endpoint: Endpoint,
	config: MutationConfig<Data, Error, Variables> | undefined
) =>
	mutationWrapper<Data, Error, Variables>('DELETE', {
		endpoint,
		config: config ?? {},
	});

export const put = <Data = unknown, Variables = void, Error = void>(
	endpoint: Endpoint,
	config: MutationConfig<Data, Error, Variables> | undefined
) =>
	mutationWrapper<Data, Error, Variables>('PUT', {
		endpoint,
		config: config ?? {},
	});

export const post = <Data = unknown, Variables = void, Error = void>(
	endpoint: Endpoint,
	config: MutationConfig<Data, Error, Variables> | undefined
) =>
	mutationWrapper<Data, Error, Variables>('POST', {
		endpoint,
		config: config ?? {},
	});

const mutationWrapper = <Data, Error, Variables>(
	type: RequestTypes,
	r: Request<Variables, Error, UseMutationOptions<Data, Error, Variables>>
): UseMutationOptions<Data, Error, Variables> => {
	const key = formatEndpoint(r.endpoint, r.config?.params)?.key ?? [];
	const onError = handleError<Variables, Error>(r.config);

	return {
		mutationKey: key,
		onError: (...args) => {
			onError(...args);
			r.config?.onError?.(...args);
		},
		// onSuccess: (...args) => {
		// 	r.config?.onSuccess(...args, queryClient.invalidateQueries, queryClient);
		// },
		networkMode: process.env.NODE_ENV === 'development' ? 'always' : undefined,
		mutationFn: async (data) =>
			await request<Data, Variables, Error>({
				endpoint: r.endpoint,
				config: {
					params: r.config.params ?? {},
					data,
					requestConfig: r.config.requestConfig,
					settings: {
						type,
						...r.config.settings,
					},
				},
			}),
		...r.config,
	};
};
